import Booking from "./Booking";
export default function Contact() {
    return (
      <>
      <div className="contact-page" id="contact-page">
    
        <section className="inner-banner-area rooms-hero">
          <img src="img/room-hero-banner.avif" className="w-100" />
          <div className="container">
            <div className="contact-banner">
                <div className="text-center">
                <h2 className="inner-banner-heading">Contact Us</h2>
                <nav aria-label="breadcrumb" className="banner-breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="index.php">Home</a></li>
                    <li className="breadcrumb-item active" aria-current="page">Contact Us</li>
                  </ol>
                </nav>
                </div>
            </div>
            </div>
        </section>

        <Booking></Booking>

       
<section className="contact-section spad">
        <div className="container">
            <div className="row">
                <div className="col-lg-6">
                    <div className="contact-left">
                      <div className="section-intro text-center pb-80px">
            <h1 className="inner-section-main-heading">Contact Information</h1>
        </div>

                        <div className="contact-information">
                            
                            <ul>
                                <li>
                                  <img src="img/placeholder-copy.png" alt="" />
                                  <span>Nelson Mandela Marg, Pocket 4, Vasant Kunj,<br/> New Delhi, Delhi - 110070</span>
                                </li>
                                <li>
                                  <img src="img/phone-copy.png" alt="" />
                                   <span>+91 11 4766 1200</span>
                                 </li>
                                <li>
                                  <img src="img/envelop.png" alt="" />
                                   <span> reservation@thegrandnewdelhi.com</span>
                                 </li>
                                <li>
                                  <img src="img/clock-copy.png" alt="" />
                                   <span>Everyday: 06:00 -22:00</span>
                                 </li>
                            </ul>
                        </div>
                        <div className="social-links">
                            <h2>Follow us on:</h2>
                            <a href="#">
                              <i className="fa-brands fa-facebook"></i>
                            </a>
                            <a href="#"><i className="fa-brands fa-instagram"></i></a>
                            <a href="#"><i className="fa-brands fa-linkedin"></i></a>
                            <a href="#"><i className="fa-brands fa-pinterest"></i></a>
                            <a href="#"><i className="fa-brands fa-twitter"></i></a>
                            <a href="#"><i className="fa-brands fa-youtube"></i></a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="contact-form">
                        <h5>Write us ...</h5>
                        <form action="#">
                            <div className="row">
                                <div className="col-lg-12">
                                    <p>From</p>
                                    <div className="input-group">
                                        <input type="text" placeholder="Full Name" />
                                        <img src="img/edit.png" alt="" />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="input-group">
                                        <input type="email" placeholder="Email" />
                                        <img src="img/envelop-copy.png" alt="" />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="input-group phone-num">
                                        <input type="text" placeholder="Phone" />
                                        <img src="img/phone-copy.png" alt="" />
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="message">
                                        <p>Message</p>
                                        <div className="textarea">
                                            <textarea placeholder="Hi ..."></textarea>
                                            <img src="img/speech-copy.png" alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <button type="submit">Submit <i className="fa fa-arrow-right"></i></button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>





</div>

      </>
    );
  }
  